import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import Status from "./Status";
import ScoreCard from "./ScoreCard";
import SuccessInfo from "./SuccessInfo"; // Import SuccessInfo component
import { getUserProfile } from "../../Common/data/getUserProfile";
import { getCandidateResults } from "../../Common/data/speedExam/getCandidateResults";

interface UserProfile {
  userId: string;
  bioDataStatus: string;
  testTakenStatus: "passed" | "failed" | "pending";
  interviewStatus: "pass" | "fail" | "pending" | "available" | "unavailable" | null;
}

const Home = () => {
  const [userProfile, setUserProfile] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState(true);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [score, setScore] = useState<string>("0");

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        console.log("Fetching user profile...");
        const data = await getUserProfile();
        console.log("User profile data:", data);

        if (data.results) {
          setUserProfile(data.results);

          // Mark initial load as complete
          if (!initialLoadComplete) {
            setInitialLoadComplete(true);
          }

          // Fetch candidate results if the test has been taken
          if (data.results.testTakenStatus === "passed" || data.results.testTakenStatus === "failed") {
            const candidateResults = await getCandidateResults();
            if (candidateResults.status === "success" && candidateResults.data.length > 0) {
              const percentage = candidateResults.data[0].percentage;
              setScore(percentage.toString());
              console.log("Fetched score:", percentage.toString());
            }
          }
        }
      } catch (error) {
        console.error("Failed to fetch user profile or candidate results", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();

    // Fetch user profile every minute
    const intervalId = setInterval(() => {
      fetchUserProfile();
    }, 60000);

    return () => clearInterval(intervalId);
  }, [initialLoadComplete]);

  if (loading) return <div>Loading...</div>;

  const interviewResult = userProfile?.interviewStatus || null;
  const testTakenStatus = userProfile?.testTakenStatus || "pending";
  const shouldRenderScoreCard = userProfile?.testTakenStatus === "passed" || userProfile?.testTakenStatus === "failed";

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Status />
      </Row>

      {shouldRenderScoreCard && (
        <ScoreCard
          score={score}
          interviewResult={interviewResult}
          testTakenStatus={testTakenStatus} // Pass testTakenStatus to ScoreCard
        />
      )}

      <SuccessInfo />
    </Container>
  );
};

export default Home;
